import React from "react";
import { usd } from "../../../../../utils/utils";

const InternalAccountsLabel = ({
  AccountHash,
  AccountLastFour,
  AccountDescription,
  AvailableBalance,
}) => {
  return (
    <div for={AccountHash}>
      <div className="bolder ellipsis" data-e2e-id={"depositAccountRadio-" + AccountLastFour}>
        {AccountDescription}
      </div>
      <div
        className="ellipsis"
        style={{
          fontSize: "12px",
        }}
      >
        {"..." + AccountLastFour + ` (${usd.format(AvailableBalance)} available)`}
      </div>
    </div>
  );
};

export default InternalAccountsLabel;



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/payment-forms/field-components/general/internal-accounts-label.component.js